export function createUuid() {
  if (globalThis.crypto?.randomUUID) return globalThis.crypto.randomUUID();

  const bytes = new Uint8Array(16);
  globalThis.crypto.getRandomValues(bytes);
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = [...bytes].map(value => value.toString(16).padStart(2, "0"));
  return `${hex.slice(0, 4).join("")}-${hex.slice(4, 6).join("")}-${hex.slice(6, 8).join("")}-${hex.slice(8, 10).join("")}-${hex.slice(10).join("")}`;
}

export function escapeHtml(value) {
  return String(value ?? "")
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#039;");
}

export function nowIso() {
  return new Date().toISOString();
}

export function localTimezoneOffset() {
  const minutes = -new Date().getTimezoneOffset();
  const sign = minutes >= 0 ? "+" : "-";
  const absolute = Math.abs(minutes);
  return `${sign}${String(Math.floor(absolute / 60)).padStart(2, "0")}:${String(absolute % 60).padStart(2, "0")}`;
}

export function formatDateTime(value) {
  if (!value) return "—";
  return new Intl.DateTimeFormat("pt-BR", {
    dateStyle: "short",
    timeStyle: "short"
  }).format(new Date(value));
}

export function durationSeconds(startedAt, finishedAt) {
  if (!startedAt || !finishedAt) return null;
  return Math.max(0, Math.round((new Date(finishedAt) - new Date(startedAt)) / 1000));
}

export function shortId(value, length = 8) {
  return String(value ?? "").split("-")[0].slice(0, length).toUpperCase();
}

export function deepClone(value) {
  if (globalThis.structuredClone) return globalThis.structuredClone(value);
  return JSON.parse(JSON.stringify(value));
}

export function normalizeText(value) {
  return String(value ?? "").trim().replace(/\s+/g, " ");
}

export function downloadJson(filename, value) {
  const blob = new Blob([JSON.stringify(value, null, 2)], { type: "application/json;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  document.body.append(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}

export function downloadText(filename, value, type = "text/plain;charset=utf-8") {
  const blob = new Blob([value], { type });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  document.body.append(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}

export function getCurrentLocation(options = {}) {
  const timeout = options.timeout ?? 8000;
  if (!navigator.geolocation) {
    return Promise.resolve({ status: "unavailable", captured_at: nowIso() });
  }
  return new Promise(resolve => {
    // The browser's timeout may exclude the time spent waiting for permission.
    let settled = false;
    const finish = result => {
      if (settled) return;
      settled = true;
      clearTimeout(timer);
      resolve({ ...result, captured_at: nowIso() });
    };
    const timer = setTimeout(() => finish({ status: "error", error_code: 3, message: "Tempo limite para obter a localização." }), timeout);
    try {
      navigator.geolocation.getCurrentPosition(
        position => finish({
          status: "captured",
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
          accuracy_m: position.coords.accuracy,
          altitude_m: position.coords.altitude,
          heading_deg: position.coords.heading,
          speed_mps: position.coords.speed
        }),
        error => finish({
          status: error.code === 1 ? "denied" : "error",
          error_code: error.code,
          message: error.message
        }),
        { enableHighAccuracy: true, timeout, maximumAge: 0 }
      );
    } catch (error) {
      finish({ status: "error", message: error.message });
    }
  });
}

export const STATUS_LABELS = Object.freeze({
  draft: "Em preenchimento",
  abandoned: "Encerrada parcialmente",
  screened_out: "Participação duplicada",
  pending: "Pendente",
  syncing: "Sincronizando",
  synced: "Sincronizada",
  error: "Erro de envio",
  superseded: "Substituída"
});
